
import moment from 'moment';
export class ShortTimeFormatValueConverter {

    public toView(value: any): string {
        if (value === undefined || value === null) {
            return value;
        }

        return moment(value).format('HH:mm');
    }
}
